
const SectionData = [
    {
        title: "Skills",
        description:`Programming Languages: Java, Python, JavaScript (Node.js), C#, Ruby, PHP, Go
        Databases: MySQL, MongoDB, PostgreSQL, SQL Server, Oracle Database
        APIs: RESTful APIs, GraphQL
        Web Services: SOAP, XML-RPC
        Frameworks and braries: Django (Python), Flask (Python), Express.js (JavaScript), Ruby on Rails (Ruby), Spring (Java), Laravel (PHP), ASP.NET (C#)
        Testing: Unit Testing, Integration Testing, System Testing, Load Testing, Performance Testing
        Tools: Git, Docker, Kubernetes, Jenkins, CI/CD`
    },
    {
        title:"Work Experience",
        description:`Programming Languages: Java, Python, JavaScript (Node.js), C#, Ruby, PHP, Go
        Databases: MySQL, MongoDB, PostgreSQL, SQL Server, Oracle Database
        APIs: RESTful APIs, GraphQL
        Web Services: SOAP, XML-RPC
        Frameworks and braries: Django (Python), Flask (Python), Express.js (JavaScript), Ruby on Rails (Ruby), Spring (Java), Laravel (PHP), ASP.NET (C#)
        Testing: Unit Testing, Integration Testing, System Testing, Load Testing, Performance Testing
        Tools: Git, Docker, Kubernetes, Jenkins, CI/CD`
    },
    {
        title:"Qualification",
        description:`Programming Languages: Java, Python, JavaScript (Node.js), C#, Ruby, PHP, Go
        Databases: MySQL, MongoDB, PostgreSQL, SQL Server, Oracle Database
        APIs: RESTful APIs, GraphQL
        Web Services: SOAP, XML-RPC
        Frameworks and braries: Django (Python), Flask (Python), Express.js (JavaScript), Ruby on Rails (Ruby), Spring (Java), Laravel (PHP), ASP.NET (C#)
        Testing: Unit Testing, Integration Testing, System Testing, Load Testing, Performance Testing
        Tools: Git, Docker, Kubernetes, Jenkins, CI/CD`
    }
]

export default SectionData;